import { useMutation } from '@tanstack/react-query'

import { redeemOfferRequest } from '~services'
import { RedeemOfferInput, RedeemOfferResponse } from '~types/offer'

export function useRedeemOffer() {
  const {
    mutateAsync: redeemOffer,
    isLoading: isLoadingRedeemOffer,
    isError: isRedeemOfferError,
    error,
  } = useMutation<RedeemOfferResponse, unknown, RedeemOfferInput>(redeemOfferRequest, {
    onError: () => {
      // Error handling for offer redemption
    },
  })
  return { redeemOffer, isLoadingRedeemOffer, isRedeemOfferError, error }
}
